import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/common/ScrollToTop/ScrollToTop';
import MainLayout from './layouts/MainLayout/MainLayout';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Programs from './pages/Programs/Programs';
import Workshops from './pages/Workshops/Workshops';
import Admissions from './pages/Admissions/Admissions';
import News from './pages/News/News';
import Salas from './pages/Salas/Salas';
import Contact from './pages/Contact/Contact';
import NotFound from './pages/NotFound/NotFound';
import { ROUTES } from './constants/routes';
import './App.css';

/**
 * Componente principal de la aplicación
 * Configura el enrutamiento y la estructura general
 */
function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path={ROUTES.HOME} element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path={ROUTES.ABOUT} element={<About />} />
          <Route path={ROUTES.PROGRAMS} element={<Programs />} />
          <Route path={ROUTES.WORKSHOPS} element={<Workshops />} />
          <Route path={ROUTES.ADMISSIONS} element={<Admissions />} />
          <Route path={ROUTES.NEWS} element={<News />} />
          <Route path={ROUTES.SALAS} element={<Salas />} />
          <Route path={ROUTES.CONTACT} element={<Contact />} />
          <Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
